import React from "react";

function Tabs({ selected, setSelected }) {
  const value = [
    "All",
    "Funded Certificates",
    "Payout Certificates",
    "Milestones",
  ];

  return (
    <div className="mt-4">
      <div className="flex flex-row gap-6">
        {value.map((item, index) => {
          return (
            <div
              key={index}
              className="text-center"
              onClick={() => setSelected(item)}
            >
              <button
                className={`text-base ${
                  item == selected
                    ? "text-primary underline underline-offset-[10.5px] font-N_Medium"
                    : "text-white-opacity"
                }`}
              >
                {item}
              </button>
            </div>
          );
        })}
      </div>
      <hr className="border-dark-new mt-1" />
    </div>
  );
}

export default Tabs;
